// Hand-authored to mirror the RTK Query codegen output for the SavedReport
// controller (apps/api/src/controllers/saved-report). It intentionally follows
// the generated `injectEndpoints` style so that a future
// `yarn nx run ui-rtk:codegen` run produces a compatible `savedReportApi.ts`.
// The only additions beyond codegen are the cache tags, which keep the report
// list fresh after create/update/delete mutations.
import { emptySplitApi as api } from "./emptyApi"
const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    savedReportControllerListReports: build.query<
      SavedReportControllerListReportsApiResponse,
      SavedReportControllerListReportsApiArg
    >({
      query: () => ({ url: `/saved-report` }),
      providesTags: ["SavedReport"],
    }),
    savedReportControllerGetReport: build.query<
      SavedReportControllerGetReportApiResponse,
      SavedReportControllerGetReportApiArg
    >({
      query: queryArg => ({ url: `/saved-report/${queryArg.id}` }),
      providesTags: ["SavedReport"],
    }),
    savedReportControllerCreateReport: build.mutation<
      SavedReportControllerCreateReportApiResponse,
      SavedReportControllerCreateReportApiArg
    >({
      query: queryArg => ({
        url: `/saved-report`,
        method: "POST",
        body: queryArg.body,
      }),
      invalidatesTags: ["SavedReport"],
    }),
    savedReportControllerUpdateReport: build.mutation<
      SavedReportControllerUpdateReportApiResponse,
      SavedReportControllerUpdateReportApiArg
    >({
      query: queryArg => ({
        url: `/saved-report/${queryArg.id}`,
        method: "PATCH",
        body: queryArg.body,
      }),
      invalidatesTags: ["SavedReport"],
    }),
    savedReportControllerDeleteReport: build.mutation<
      SavedReportControllerDeleteReportApiResponse,
      SavedReportControllerDeleteReportApiArg
    >({
      query: queryArg => ({
        url: `/saved-report/${queryArg.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["SavedReport"],
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as generatedApi }

export type SavedReportDto = {
  id: string
  companyId: string
  ownerUserId: string
  name: string
  description: string | null
  isPrivate: boolean
  config: Record<string, unknown>
  createdAt: string
  updatedAt: string
}
export type CreateSavedReportDto = {
  name: string
  description?: string
  isPrivate?: boolean
  config: Record<string, unknown>
}
export type UpdateSavedReportDto = {
  name?: string
  description?: string
  isPrivate?: boolean
  config?: Record<string, unknown>
}
export type SavedReportControllerListReportsApiResponse =
  /** status 200  */ SavedReportDto[]
export type SavedReportControllerListReportsApiArg = void
export type SavedReportControllerGetReportApiResponse =
  /** status 200  */ SavedReportDto
export type SavedReportControllerGetReportApiArg = {
  id: string
}
export type SavedReportControllerCreateReportApiResponse =
  /** status 200  */ SavedReportDto
export type SavedReportControllerCreateReportApiArg = {
  body: CreateSavedReportDto
}
export type SavedReportControllerUpdateReportApiResponse =
  /** status 200  */ SavedReportDto
export type SavedReportControllerUpdateReportApiArg = {
  id: string
  body: UpdateSavedReportDto
}
export type SavedReportControllerDeleteReportApiResponse = /** status 200  */ {
  success: boolean
}
export type SavedReportControllerDeleteReportApiArg = {
  id: string
}
export const {
  useSavedReportControllerListReportsQuery,
  useSavedReportControllerGetReportQuery,
  useSavedReportControllerCreateReportMutation,
  useSavedReportControllerUpdateReportMutation,
  useSavedReportControllerDeleteReportMutation,
} = injectedRtkApi
